"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto p-4" };
const _hoisted_2 = { class: "text-xl sm:text-2xl mb-4 sm:my-5 sm:ml-5 font-bold uppercase text-center sm:text-left" };
const _hoisted_3 = { class: "bg-white p-5 mb-4" };
const _hoisted_4 = { class: "flex gap-2" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const _hoisted_7 = { class: "bg-white p-5 mb-4" };
const _hoisted_8 = { class: "flex justify-between items-center uppercase font-bold text-base sm:text-xl border-b-1 border-gray pb-3" };
const _hoisted_9 = { class: "flex items-center gap-2" };
const _hoisted_10 = { class: "flex flex-wrap text-sm sm:text-base" };
const _hoisted_11 = ["checked", "value"];
const _hoisted_12 = { class: "bg-white p-5 mb-4" };
const _hoisted_13 = { class: "flex justify-between items-center uppercase font-bold text-base sm:text-xl border-b-1 border-gray pb-3" };
const _hoisted_14 = { class: "flex items-center gap-2" };
const _hoisted_15 = { class: "flex flex-wrap text-sm sm:text-base" };
const _hoisted_16 = ["checked", "value"];
const _hoisted_17 = { class: "bg-white p-5 mb-4" };
const _hoisted_18 = { class: "flex flex-col md:flex-row gap-5 items-center uppercase text-base sm:text-xl" };
const _hoisted_19 = { class: "flex-shrink-0 font-bold" };
const _hoisted_20 = { class: "flex w-full items-center" };
const _hoisted_21 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex items-center justify-center h-12 w-12 text-gray-dark border border-l-0 border-gray-dark border-opacity-50 font-bold" }, " % ", -1);
const _hoisted_22 = {
    key: 0,
    class: "bg-white p-5 mb-4 text-sm sm:text-base"
};
const _hoisted_23 = { class: "uppercase font-bold text-base sm:text-xl text-center sm:text-left border-b-1 border-gray pb-3" };
const _hoisted_24 = { class: "flex flex-col my-4" };
const _hoisted_25 = { class: "text-white font-bold" };
const _hoisted_26 = {
    key: 0,
    class: "marso-icon-chevron-up text-xl"
};
const _hoisted_27 = {
    key: 1,
    class: "marso-icon-chevron-down text-xl"
};
const _hoisted_28 = {
    key: 0,
    class: "flex gap-2 py-2"
};
const _hoisted_29 = { class: "flex justify-between items-center p-2 pr-4 pl-4 cursor-pointer" };
const _hoisted_30 = { class: "flex flex-col sm:flex-row items-center gap-2" };
const _hoisted_31 = { class: "flex-shrink-0 uppercase" };
const _hoisted_32 = { class: "flex" };
const _hoisted_33 = { class: "flex" };
const _hoisted_34 = ["onClick"];
const _hoisted_35 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_36 = ["onClick"];
const _hoisted_37 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const _hoisted_38 = ["onClick"];
const _hoisted_39 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
    key: 0,
    class: "marso-icon-chevron-up text-xl"
};
const _hoisted_42 = {
    key: 1,
    class: "marso-icon-chevron-down text-xl"
};
const _hoisted_43 = {
    key: 0,
    class: "hidden sm:flex items-center bg-gray-dark p-2 pr-4 pl-4 text-white uppercase font-bold gap-5"
};
const _hoisted_44 = { class: "w-[15%]" };
const _hoisted_45 = { class: "w-[70%] text-center lg:text-left" };
const _hoisted_46 = ["onClick"];
const _hoisted_47 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_48 = { key: 1 };
const _hoisted_49 = { class: "flex flex-col gap-5 sm:hidden bg-gray-dark text-white uppercase font-bold p-2 pr-4 pl-4" };
const _hoisted_50 = { class: "flex flex-col sm:flex-row gap-5 items-center w-full p-2 pr-4 pl-4" };
const _hoisted_51 = { class: "sm:w-[15%] min-w-max" };
const _hoisted_52 = { class: "sm:w-[70%] flex items-center justify-center sm:justify-start gap-x-2 sm:gap-x-4 gap-y-2 flex-wrap" };
const _hoisted_53 = ["onClick"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_56 = {
    key: 0,
    class: "flex justify-center items-center gap-4 p-4 bg-gray w-full"
};
const _hoisted_57 = ["disabled", "onClick"];
const _hoisted_58 = { class: "bg-white p-2 sm:p-4" };
const _hoisted_59 = ["disabled", "onClick"];
const _hoisted_60 = { class: "flex flex-col justify-center gap-2 p-3 sm:p-5" };
const _hoisted_61 = {
    key: 0,
    class: "text-sm sm:text-base font-bold mx-auto"
};
const _hoisted_62 = ["disabled"];
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const vue_router_1 = require("vue-router");
const Form_1 = require("../../components/Form");
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
const pricingStore_1 = require("../../stores/pricing/pricingStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const PricingEnum_1 = require("../../stores/pricing/PricingEnum");
const securityStore_1 = require("../../stores/security/securityStore");
const PricingConflictModal_vue_1 = __importDefault(require("./PricingConflictModal.vue"));
const ToastPosition_1 = require("../../stores/toast/ToastPosition");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'PercentPricing',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const pricingStore = (0, pricingStore_1.usePricingStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const brands = (0, vue_3.ref)([]);
        const diameters = (0, vue_3.ref)([]);
        const selectedBrands = (0, vue_3.ref)([]);
        const selectedDiameters = (0, vue_3.ref)([]);
        const expandedRow = (0, vue_3.ref)(null);
        const percentageInputIsActive = (0, vue_3.ref)({});
        const nameInputIsActive = (0, vue_3.ref)(false);
        const percentageValues = (0, vue_3.ref)({});
        const pricingFilters = (0, vue_3.ref)([]);
        const percentValue = (0, vue_3.ref)(null);
        const rowPercentInputValue = (0, vue_3.ref)(null);
        const conflictsModalIsOpen = (0, vue_3.ref)(false);
        const pricingConflicts = (0, vue_3.ref)([]);
        const conflictSaveButtonIsActive = (0, vue_3.ref)(false);
        const expandedConflictRow = (0, vue_3.ref)(null);
        const currentPages = (0, vue_3.ref)({});
        const itemsPerPage = (0, vue_3.ref)(5);
        const selectedFilters = (0, vue_3.ref)({});
        const filtersOpen = (0, vue_3.ref)(false);
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const filters = (0, vue_3.computed)(() => {
            return {
                brands: brands.value.map(brand => brand.value),
                diameters: diameters.value
            };
        });
        // A szűrők elemeit elsőként a százalék, majd a márka alapján csoportosítjuk, és az egyes csoportokhoz hozzáadjuk az átmérőket és id-kat.
        const groupedFilters = (0, vue_3.computed)(() => {
            const grouped = {};
            pricingFilters.value.forEach((filter) => {
                const { percentPricing: percent, brand, diameter, id } = filter;
                // Szűrés a kiválasztott szűrők alapján.
                if ((selectedFilters.value.brand && selectedFilters.value.brand !== brand) ||
                    (selectedFilters.value.diameter && selectedFilters.value.diameter !== diameter)) {
                    return;
                }
                // Csoportosítás.
                if (!grouped[percent]) {
                    grouped[percent] = {};
                    if (!percentageValues.value[percent]) {
                        percentageValues.value[percent] = percent;
                    }
                    percentageInputIsActive.value[percent] = true;
                }
                if (!grouped[percent][brand]) {
                    grouped[percent][brand] = { diameter: [], id: [] };
                }
                grouped[percent][brand].diameter.push(diameter);
                grouped[percent][brand].id.push(id);
            });
            return grouped;
        });
        const groupedConflicts = (0, vue_3.computed)(() => {
            const conflictMap = new Map();
            pricingConflicts.value.forEach(conflict => {
                const { customerPricingId, customerPricingName, customerPricingType } = conflict;
                if (!conflictMap.has(customerPricingId)) {
                    conflictMap.set(customerPricingId, {
                        id: customerPricingId,
                        name: customerPricingName,
                        type: customerPricingType,
                        conflicts: []
                    });
                }
                conflictMap.get(customerPricingId).conflicts.push(conflict);
            });
            return Array.from(conflictMap.values());
        });
        (0, vue_3.onMounted)(() => {
            if (pricingStore.pricingId) {
                getPricingFilters(pricingStore.pricingId);
                getTyreBrandsAndDiameters();
            }
            else {
                navigateToPricing();
            }
        });
        (0, vue_3.onUnmounted)(async () => {
            // Ha elnavigál és nincs filter az árazásban, akkor a státuszt inaktívra állítjuk.
            // Ellenkező esetben csak simán átírányítjuk.
            if (!pricingFilters.value.length) {
                if (!pricingStore.pricingId)
                    return;
                try {
                    await pricingStore.updatePricing(router, { status: PricingEnum_1.PricingStatusEnum.INACTIVE }, pricingStore.pricingId);
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            pricingStore.resetState();
        });
        const getPricingFilters = async (pricingId) => {
            if (pricingId) {
                try {
                    const response = await pricingStore.getPricings(router, undefined, pricingId);
                    if (response.customerPricingFilters.length) {
                        pricingFilters.value = response.customerPricingFilters;
                    }
                    else {
                        pricingFilters.value = [];
                    }
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const getTyreBrandsAndDiameters = async () => {
            if (pricingStore.axCategories.length) {
                try {
                    const result = await productFilterStore.getProductFilters(router, { axCategories: pricingStore.axCategories, active: 1 });
                    brands.value = Object.entries(result.brands.values).map(([key, value]) => ({ key, value: String(value) }));
                    diameters.value = result.diameters.values;
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const selectAllBrands = () => {
            selectedBrands.value = brands.value.map(brand => brand.value);
        };
        const selectAllDiameters = () => {
            selectedDiameters.value = diameters.value;
        };
        const unselectAllBrands = () => {
            selectedBrands.value = [];
        };
        const unselectAllDiameters = () => {
            selectedDiameters.value = [];
        };
        const addPricingFilter = async () => {
            if (pricingStore.pricingId &&
                selectedBrands.value &&
                selectedDiameters.value &&
                percentValue.value) {
                if (percentValue.value == 0) {
                    percentValue.value = null;
                    return;
                }
                try {
                    await pricingStore.createPricingFilter(router, {
                        customerPricingId: pricingStore.pricingId,
                        percentPricing: Number(percentValue.value),
                        brands: selectedBrands.value,
                        diameters: selectedDiameters.value
                    });
                    await getPricingFilters(pricingStore.pricingId);
                    pricingStore.pricingStatus = PricingEnum_1.PricingStatusEnum.INACTIVE;
                    await pricingStore.updatePricing(router, { status: pricingStore.pricingStatus }, pricingStore.pricingId);
                    selectedBrands.value = [];
                    selectedDiameters.value = [];
                    percentValue.value = null;
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_filter_added_successfully", "Pricing filter added successfully!", "percent_pricing"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addToast({
                        message: error.toString(),
                        type: "danger",
                        timer: 30,
                        position: ToastPosition_1.ToastPosition.Center,
                    });
                }
            }
            else {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("please_fill_in_all_fields_text", "Please fill in all fields before adding pricing filters.", "percent_pricing"),
                    type: "danger",
                    timer: 5,
                });
            }
        };
        const updatePricing = async (percent) => {
            if (pricingStore.pricingId && rowPercentInputValue.value !== null) {
                const filtersToUpdate = groupedFilters.value[percent];
                const updatedFilters = Object.entries(filtersToUpdate).flatMap(([brand, group]) => group.id.map((id, index) => ({
                    id: id,
                    diameter: group.diameter[index],
                    brand: brand,
                    percentPricing: Number(rowPercentInputValue.value),
                })));
                try {
                    await pricingStore.updatePricing(router, { customerPricingFilters: updatedFilters }, pricingStore.pricingId);
                    await getPricingFilters(pricingStore.pricingId);
                    rowPercentInputValue.value = null;
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_updated_successfully", "Pricing updated successfully!", "percent_pricing"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const deletePricingFilter = async (filterId) => {
            try {
                await pricingStore.deletePricingFilters(router, { filterIds: filterId });
                await getPricingFilters(pricingStore.pricingId);
                toastStore.addToast({
                    message: (0, i18n_1.trans)("pricing_filter_deleted_successfully", "Pricing filter deleted successfully!", "percent_pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const deletePricingFilters = async (percent) => {
            const filterIdsToDelete = pricingFilters.value
                .filter(filter => filter.percentPricing == percent)
                .map(filter => filter.id);
            if (filterIdsToDelete.length) {
                try {
                    await pricingStore.deletePricingFilters(router, { filterIds: filterIdsToDelete });
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_filters_deleted_successfully", "Pricing filters deleted successfully!", "percent_pricing"),
                        type: "success",
                        timer: 5,
                    });
                    await getPricingFilters(pricingStore.pricingId);
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const deleteConflictedPricingFilter = async (filterId) => {
            if (!pricingStore.pricingId)
                return;
            try {
                await pricingStore.deletePricingFilter(router, [filterId]);
                await getPricingFilters(pricingStore.pricingId);
                const response = await pricingStore.checkPricingConflict(router, pricingStore.pricingId);
                if (response.message === "Conflicts found") {
                    pricingConflicts.value = response.conflicts;
                }
                else {
                    pricingConflicts.value = response.conflicts;
                    conflictSaveButtonIsActive.value = true;
                }
                toastStore.addToast({
                    message: (0, i18n_1.trans)("conflicted_pricing_filter_deleted_successfully", "Conflicted pricing filter deleted successfully!", "percent_pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const deleteConflictedPricingFilters = async (id) => {
            const filterIdsToDelete = pricingConflicts.value
                .filter(filter => filter.customerPricingId === id)
                .map(filter => filter.conflictingFilter.id);
            if (filterIdsToDelete.length && pricingStore.pricingId) {
                try {
                    await pricingStore.deletePricingFilters(router, { filterIds: filterIdsToDelete });
                    await getPricingFilters(pricingStore.pricingId);
                    const response = await pricingStore.checkPricingConflict(router, pricingStore.pricingId);
                    if (response.message === "Conflicts found") {
                        pricingConflicts.value = response.conflicts;
                    }
                    else {
                        pricingConflicts.value = response.conflicts;
                        conflictSaveButtonIsActive.value = true;
                    }
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_filters_deleted_successfully", "Pricing filters deleted successfully!", "percent_pricing"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const expandRowToggle = (percent) => {
            if (expandedRow.value === percent) {
                expandedRow.value = null;
            }
            else {
                expandedRow.value = percent;
                currentPages.value[percent] = 1;
            }
        };
        const expandConflictRowToggle = (value) => {
            expandedConflictRow.value = value;
        };
        const editPercentage = (percent) => {
            percentageInputIsActive.value[percent] = false;
        };
        const savePercentage = (percent) => {
            if (rowPercentInputValue.value == 0) {
                rowPercentInputValue.value = null;
                percentageInputIsActive.value[percent] = true;
                return;
            }
            percentageInputIsActive.value[percent] = true;
            percentageValues.value[percent] = Number(rowPercentInputValue.value);
            updatePricing(percent);
        };
        const editName = () => {
            nameInputIsActive.value = true;
        };
        const saveName = async () => {
            if (!pricingStore.pricingId)
                return;
            try {
                await pricingStore.updatePricing(router, { name: pricingStore.pricingName }, pricingStore.pricingId);
                nameInputIsActive.value = false;
                toastStore.addToast({
                    message: (0, i18n_1.trans)("pricing_name_updated_successfully", "Pricing name updated successfully!", "percent_pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const navigateToPricing = () => {
            pricingStore.resetState();
            conflictsModalIsOpen.value = false;
            router.push({ name: 'pricing' });
        };
        const finalisePricing = async () => {
            if (!pricingStore.pricingId)
                return;
            try {
                const response = await pricingStore.checkPricingConflict(router, pricingStore.pricingId);
                if (response.message === "Conflicts found") {
                    pricingConflicts.value = response.conflicts;
                    conflictsModalIsOpen.value = true;
                }
                else {
                    activatePricing();
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const activatePricing = async () => {
            if (!pricingStore.pricingId)
                return;
            if (pricingStore.pricingStatus === PricingEnum_1.PricingStatusEnum.INACTIVE) {
                try {
                    await pricingStore.updatePricing(router, { status: PricingEnum_1.PricingStatusEnum.ACTIVE }, pricingStore.pricingId);
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_activated_successfully", "Pricing activated successfully!", "percent_pricing"),
                        type: "success",
                        timer: 5,
                    });
                    navigateToPricing();
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            else {
                navigateToPricing();
            }
        };
        const saveAndDeactivatePricing = async () => {
            for (const conflict of pricingConflicts.value) {
                try {
                    await pricingStore.updatePricing(router, { status: PricingEnum_1.PricingStatusEnum.INACTIVE }, conflict.customerPricingId);
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            if (pricingConflicts.value.length > 1) {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("pricings_deactivated_successfully", "Pricings deactivated successfully!", "percent_pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            else {
                toastStore.addToast({
                    message: (0, i18n_1.trans)("pricing_deactivated_successfully", "Pricing deactivated successfully!", "percent_pricing"),
                    type: "success",
                    timer: 5,
                });
            }
            activatePricing();
            navigateToPricing();
        };
        const paginatedGroup = (group, percent) => {
            const currentPage = currentPages.value[percent] || 1;
            const start = (currentPage - 1) * itemsPerPage.value;
            const end = start + itemsPerPage.value;
            const groupArray = Object.entries(group);
            return groupArray.slice(start, end);
        };
        const totalPages = (group) => {
            const groupArray = Object.entries(group);
            return groupArray ? Math.ceil(groupArray.length / itemsPerPage.value) : 0;
        };
        const toggleFilters = () => filtersOpen.value = !filtersOpen.value;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('percent_pricing', 'Percent pricing', 'percent_pricing')), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: (0, vue_2.unref)(pricingStore).pricingName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (((0, vue_2.unref)(pricingStore).pricingName) = $event)),
                            disabled: !nameInputIsActive.value,
                            type: "text",
                            border: ""
                        }, null, 8, ["modelValue", "disabled"]),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-primary btn-link !text-sm sm:!text-base",
                            onClick: editName
                        }, [
                            _hoisted_5,
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('edit', 'Edit', 'percent_pricing')), 1)
                        ]),
                        (nameInputIsActive.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                key: 0,
                                class: "btn btn-primary btn-link !text-sm sm:!text-base",
                                onClick: saveName
                            }, [
                                _hoisted_6,
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('save', 'Save', 'percent_pricing')), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('select_brands', 'Select brands', 'percent_pricing')), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (selectedBrands.value.length)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", {
                                    key: 0,
                                    class: "marso-icon-remove text-xl sm:text-2xl cursor-pointer",
                                    onClick: unselectAllBrands
                                }))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-secondary btn-outline !text-sm sm:!text-base",
                                onClick: selectAllBrands
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("select_all", "Select all", "percent_pricing")), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(brands.value, (brand) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                key: brand.key,
                                class: "flex items-center p-3 sm:p-4 w-1/2 sm:w-1/3 lg:w-1/4 xl:w-1/5"
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedBrands).value = $event)),
                                    checked: selectedBrands.value.includes(brand.key),
                                    class: "sm:w-6 sm:h-6 mr-2 accent-blue",
                                    type: "checkbox",
                                    value: brand.value
                                }, null, 8, _hoisted_11), [
                                    [vue_2.vModelCheckbox, selectedBrands.value]
                                ]),
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(brand.value), 1)
                            ]));
                        }), 128))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_12, [
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('select_sizes', 'Select sizes', 'percent_pricing')), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (selectedDiameters.value.length)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", {
                                    key: 0,
                                    class: "marso-icon-remove text-xl sm:text-2xl cursor-pointer",
                                    onClick: unselectAllDiameters
                                }))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-secondary btn-outline !text-sm sm:!text-base",
                                onClick: selectAllDiameters
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("select_all", "Select all", "percent_pricing")), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_15, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(diameters.value, (diameter, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                key: index,
                                class: "flex items-center p-3 sm:p-4 w-1/2 sm:w-1/3 lg:w-1/4 xl:w-1/5"
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedDiameters).value = $event)),
                                    checked: selectedDiameters.value.includes(diameter),
                                    class: "sm:w-6 sm:h-6 mr-2 accent-blue",
                                    type: "checkbox",
                                    value: diameter
                                }, null, 8, _hoisted_16), [
                                    [vue_2.vModelCheckbox, selectedDiameters.value]
                                ]),
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(diameter), 1)
                            ]));
                        }), 128))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                    (0, vue_2.createElementVNode)("div", _hoisted_18, [
                        (0, vue_2.createElementVNode)("span", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('enter_the_percentage', 'Enter the percentage (net)', 'percent_pricing')), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_20, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                modelValue: percentValue.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((percentValue).value = $event)),
                                type: "number",
                                min: 0,
                                border: "",
                                onInput: _cache[4] || (_cache[4] = ($event) => (percentValue.value = $event.target.value))
                            }, null, 8, ["modelValue"]),
                            _hoisted_21
                        ]),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary w-full md:w-auto flex-shrink-0 !text-sm sm:!text-base",
                            onClick: addPricingFilter
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_pricing_filter", "Add pricing filter", "percent_pricing")), 1)
                    ])
                ]),
                (pricingFilters.value.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                        (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('priced_products', 'Priced products', 'percent_pricing')), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                            (0, vue_2.createElementVNode)("div", {
                                class: "flex justify-between items-center cursor-pointer bg-gray-dark px-4 py-2",
                                onClick: toggleFilters
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('filtering_priced_products', 'Filtering priced products', 'percent_pricing')), 1),
                                (filtersOpen.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_26))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_27))
                            ]),
                            (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (filtersOpen.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_28, [
                                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                                modelValue: selectedFilters.value.brand,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedFilters.value.brand) = $event)),
                                                placeholder: (0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'percent_pricing'),
                                                items: (0, vue_2.unref)(filters).brands
                                            }, null, 8, ["modelValue", "placeholder", "items"]),
                                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                                modelValue: selectedFilters.value.diameter,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedFilters.value.diameter) = $event)),
                                                placeholder: (0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'percent_pricing'),
                                                items: (0, vue_2.unref)(filters).diameters
                                            }, null, 8, ["modelValue", "placeholder", "items"])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(groupedFilters), (group, percent) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: percent,
                                class: (0, vue_2.normalizeClass)(["border-1 border-gray even:bg-gray", expandedRow.value === percent ? 'border-gray-darker' : ''])
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('percentage', 'Percentage', 'percent_pricing')) + ": ", 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                            (percentageInputIsActive.value[percent])
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.ShopInput), {
                                                    key: 0,
                                                    modelValue: percentageValues.value[percent],
                                                    "onUpdate:modelValue": ($event) => ((percentageValues.value[percent]) = $event),
                                                    disabled: percentageInputIsActive.value[percent],
                                                    type: "number",
                                                    min: 0,
                                                    border: ""
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.ShopInput), {
                                                    key: 1,
                                                    modelValue: rowPercentInputValue.value,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((rowPercentInputValue).value = $event)),
                                                    value: percentageValues.value[percent],
                                                    disabled: percentageInputIsActive.value[percent],
                                                    placeholder: `${percentageValues.value[percent]}%`,
                                                    type: "number",
                                                    min: 0,
                                                    border: "",
                                                    onInput: _cache[8] || (_cache[8] = ($event) => (rowPercentInputValue.value = $event.target.value))
                                                }, null, 8, ["modelValue", "value", "disabled", "placeholder"]))
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                            (percentageInputIsActive.value[percent])
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: 0,
                                                    class: "btn btn-primary btn-link !text-sm sm:!text-base",
                                                    onClick: ($event) => (editPercentage(percent))
                                                }, [
                                                    _hoisted_35,
                                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('edit', 'Edit', 'percent_pricing')), 1)
                                                ], 8, _hoisted_34))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: 1,
                                                    class: "btn btn-primary btn-link !text-sm sm:!text-base",
                                                    onClick: ($event) => (savePercentage(percent))
                                                }, [
                                                    _hoisted_37,
                                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('save', 'Save', 'percent_pricing')), 1)
                                                ], 8, _hoisted_36)),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "btn btn-danger btn-link sm:hidden !text-sm sm:!text-base",
                                                onClick: ($event) => (deletePricingFilters(percent))
                                            }, [
                                                _hoisted_39,
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('delete_all', 'Delete all', 'percent_pricing')), 1)
                                            ], 8, _hoisted_38)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-primary btn-link !text-gray-darker !text-sm sm:!text-base",
                                        onClick: ($event) => (expandRowToggle(percent))
                                    }, [
                                        (expandedRow.value === percent)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_41))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_42))
                                    ], 8, _hoisted_40)
                                ]),
                                (expandedRow.value === percent)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_43, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_44, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'percent_pricing')), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_45, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'percent_pricing')), 1),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "w-[15%] btn btn-danger btn-link !text-sm sm:!text-base",
                                            onClick: ($event) => (deletePricingFilters(percent))
                                        }, [
                                            _hoisted_47,
                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('delete_all', 'Delete all', 'percent_pricing')), 1)
                                        ], 8, _hoisted_46)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (expandedRow.value === percent)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_48, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(paginatedGroup(group, percent), ([brand, data], i) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: brand,
                                                class: (0, vue_2.normalizeClass)([i % 2 === 0 ? 'odd:bg-white' : 'even:bg-gray', "flex gap-10 items-center"])
                                            }, [
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: (0, vue_2.normalizeClass)(["flex w-full sm:border-none", i !== paginatedGroup(group, percent).length - 1 ? 'border-b-1 border-gray border-gray-darker' : ''])
                                                }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'percent_pricing')), 1),
                                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'percent_pricing')), 1)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_50, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_51, (0, vue_2.toDisplayString)(brand), 1),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_52, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(data.diameter, (diameter, index) => {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                    key: diameter,
                                                                    class: "flex items-center justify-center gap-1 sm:text-lg w-20 h-8"
                                                                }, [
                                                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(diameter), 1),
                                                                    (0, vue_2.createElementVNode)("i", {
                                                                        class: "marso-icon-trash text-red cursor-pointer",
                                                                        onClick: ($event) => (deletePricingFilter([data.id[index]]))
                                                                    }, null, 8, _hoisted_53)
                                                                ]));
                                                            }), 128))
                                                        ]),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "sm:w-[15%] min-w-max btn btn-danger btn-link !text-sm sm:!text-base",
                                                            onClick: ($event) => (deletePricingFilter(data.id))
                                                        }, [
                                                            _hoisted_55,
                                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "pricing")), 1)
                                                        ], 8, _hoisted_54)
                                                    ])
                                                ], 2)
                                            ], 2));
                                        }), 128)),
                                        (totalPages(group) > 1)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_56, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn btn-rounded btn-primary !text-sm sm:!text-base",
                                                    disabled: currentPages.value[percent] === 1,
                                                    onClick: ($event) => (currentPages.value[percent]--)
                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("previous", "Previous", "percent_pricing")), 9, _hoisted_57),
                                                (0, vue_2.createElementVNode)("div", _hoisted_58, (0, vue_2.toDisplayString)(currentPages.value[percent]) + " / " + (0, vue_2.toDisplayString)(totalPages(group)), 1),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn btn-rounded btn-primary !text-sm sm:!text-base",
                                                    disabled: currentPages.value[percent] === totalPages(group),
                                                    onClick: ($event) => (currentPages.value[percent]++)
                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("next", "Next", "percent_pricing")), 9, _hoisted_59)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ], 2));
                        }), 128))
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_60, [
                    (!pricingFilters.value.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_61, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("activate_pricing_explanation_text", "You can only activate pricing if you have previously added pricing filters using the add pricing filter button.", "percent_pricing")), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-success !text-sm sm:!text-base mx-auto",
                        disabled: !pricingFilters.value.length,
                        onClick: finalisePricing
                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("activate_pricing", "Activate pricing", "percent_pricing")), 9, _hoisted_62)
                ]),
                (0, vue_2.createVNode)(PricingConflictModal_vue_1.default, {
                    "is-open": conflictsModalIsOpen.value,
                    "conflict-save-button-is-active": conflictSaveButtonIsActive.value,
                    "pricing-conflicts": pricingConflicts.value,
                    "grouped-conflicts": (0, vue_2.unref)(groupedConflicts),
                    "expanded-conflict-row": expandedConflictRow.value,
                    "current-user": (0, vue_2.unref)(currentUser),
                    "onUpdate:isOpen": navigateToPricing,
                    "onUpdate:expandedConflictRow": expandConflictRowToggle,
                    onDeleteConflictedPricingFilter: deleteConflictedPricingFilter,
                    onDeleteConflictedPricingFilters: deleteConflictedPricingFilters,
                    onSaveAndDeactivatePricing: saveAndDeactivatePricing,
                    onActivatePricing: activatePricing
                }, null, 8, ["is-open", "conflict-save-button-is-active", "pricing-conflicts", "grouped-conflicts", "expanded-conflict-row", "current-user"])
            ]));
        };
    }
});
